const rootPath = '/videos';

const videoMaterials = {
  manMeditatingPoster: `${rootPath}/man-meditating-poster.png`,
};

export default videoMaterials;
